import {inject, injectable} from "inversify";
import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {TransferOffer, TransferOfferCareerEndNotification} from "../entity";
import {TransferOfferStatusEnum} from "@/modules/transfer-market/enums";
import {BeforePlayerCareerPlanedEndEvent} from "@/modules/team/events/BeforePlayerCareerPlanedEndEvent";
import {TransferOfferHandler} from "@/modules/transfer-market/services/TransferOfferHandler";
import {Notifier} from "@/modules/notifications/services/Notifier";
import {NegotiationCloser} from "@/modules/diplomacy/services/NegotiationCloser";

@injectable()
export default class TransferOfferEventSubscriber implements EventSubscriber {
  constructor(
    @inject(NegotiationCloser) private negotiationCloser: NegotiationCloser,
    @inject(TransferOfferHandler) private transferOfferHandler: TransferOfferHandler,
    @inject(Notifier) private notifier: Notifier,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforePlayerCareerPlanedEndEvent, callback: this.onBeforePlayerCareerPlanedEndEvent},
    ];
  }

  public async onBeforePlayerCareerPlanedEndEvent(event: BeforePlayerCareerPlanedEndEvent) {
    const offers = await TransferOffer
      .createQueryBuilder('offer')
      .leftJoinAndSelect('offer.listing', 'listing')
      .innerJoinAndSelect('offer.player', 'player')
      .innerJoinAndSelect('offer.team', 'team')
      .leftJoinAndSelect('offer.teamNegotiation', 'teamNegotiation')
      .innerJoinAndSelect('offer.playerNegotiation', 'playerNegotiation')
      .where(`player.id = :playerId`, {playerId: event.player.id})
      .andWhere('offer.status = :offerStatus', {offerStatus: TransferOfferStatusEnum.OPENED})
      .getMany();

    await offers.forEachAsync(async (offer: TransferOffer) => {
      await this.transferOfferHandler.abort(offer);

      if (offer.team.user) {
        await this.notifier.notify(
          new TransferOfferCareerEndNotification().setPayload(event.player)
        );
      }
    });
  }
}
